import { Serializable } from './ISerializeable';

export abstract class DBModel extends Serializable {
  _id: string = undefined;
  _rev: string = undefined;

  override serialize(): any {
    var obj: any = super.serialize();

    obj._id = this._id;
    obj._rev = this._rev;

    return obj;
  }

  override deserialize(data: any) {
    if (data._id != undefined) this._id = data._id;
    if (data._rev != undefined) this._rev = data._rev;
  }
}
